export default __webpack_public_path__ + "static/media/slackclass.e26e9279.jpg";